<template>
  <inventoryProductsCategoriesForm :typeEndPoint="'restaurantProductsSubCategoriesShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsCategoriesForm from '@/components/modules/restaurant/products/subcategories/form'
export default {
  name: 'inventoryProductsCategories',
  components: {
    inventoryProductsCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/subcategories/edit.vue